import { makeStyles } from '@material-ui/core/styles';
import React, { useMemo } from 'react';

import type { IInvoice } from 'v2/interfaces/invoice';
import type { ISubscriptionInvoice } from 'v2/interfaces/subscriptions';

interface IProps {
  invoice: IInvoice | ISubscriptionInvoice;
}

const useStyles = makeStyles(() => ({
  paymentImg: {
    width: 30,
  },
}));

interface IPaymentType {
  img: string;
  title: string;
}

const PaymentTypeImg = ({ invoice }: IProps) => {
  const classes = useStyles();

  const paymentType: IPaymentType = useMemo(() => {
    if ((invoice as IInvoice).tags.is_terminal) {
      return { img: '/img/brands/payment/Desconhecido.svg', title: 'Bandeira desconhecida' };
    }

    if (invoice.card_brand) {
      return { img: `/img/brands/payment/${invoice.card_brand}.svg`, title: invoice.card_brand };
    }
    if (invoice.payment_method?.name === null) {
      return { img: '/img/brands/payment/Desconhecido.svg', title: 'Desconhecido' };
    }

    return { img: '/img/brands/payment/Boleto.svg', title: 'Boleto' };
  }, [invoice]);

  return <img className={classes.paymentImg} alt={paymentType.title} title={paymentType.title} src={paymentType.img} />;
};

export default PaymentTypeImg;
